import { FieldType } from '@/components/Form';
import { DatabaseField } from '@/modules/corporate/modules/database/fields/types';

import RatingFieldEditorConfig from './Editor/config';
import Cell from './Cell';
import { RatingFieldStaticConfig } from './config';
import EditableCell from './EditableCell';
import FilterInput from './FilterInput';
import RatingOperators from './operators';
import TableOptions from './TableOptions';
import { adaptFormField, adaptRatingField, parseFormData } from './utils';

const RatingField: DatabaseField = {
  ...RatingFieldStaticConfig,
  Table: {
    Cell,
    EditableCell,
    FilterInput,
    operators: RatingOperators,
    TableOptions,
  },
  Viewer: {
    adaptFormField,
    parseFormData,
    fieldType: FieldType.Rating,
  },
  Editor: RatingFieldEditorConfig,
  adaptField: adaptRatingField,
};

export default RatingField;
